module.exports = __webpack_public_path__ + "static/media/sb_symbol.d283d113.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/sb_symbol.png
// module id = 386
// module chunks = 0